import React, { useContext } from 'react';
import AppContext from '../context/Context';
import BanksRoutes from '../routes/BanksRoutes';

const BanksLayout = ( ) => {
    const { isFluid } = useContext(AppContext);

    return  <div className={isFluid ? 'container-fluid' : 'container'}>
                <BanksRoutes />
            </div>
}

export default BanksLayout;